"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const Flex = (0, styled_components_1.default)(material_1.Box) `
  display: flex;
  flex-direction: ${(props) => props.direction || 'row'};
  width: ${(props) => props.w || '100%'};
  height: ${(props) => props.h || 'auto'};
  align-items: ${(props) => props.align || 'flex-start'};
  justify-content: ${(props) => props.justify || 'flex-start'};
  flex-grow: ${(props) => props.grow || 0};
  flex-wrap: ${(props) => props.wrap || 'wrap'};
  gap: ${(props) => props.gap || 'none'};
`;
exports.default = Flex;
